import * as React from 'react';

const DeleteIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <div className="border border-[#C5C5C5] bg-[#fff] rounded-[4px] w-[30px] h-[30px] flex justify-center items-center cursor-pointer">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.6">
        <path
          d="M13 10.5556V15.6111M10 10.5556V15.6111M7 7.66667V16.1889C7 16.9979 7 17.4021 7.16349 17.711C7.3073 17.9828 7.5366 18.2042 7.81885 18.3427C8.1394 18.5 8.55925 18.5 9.39768 18.5H13.6023C14.4408 18.5 14.86 18.5 15.1805 18.3427C15.4628 18.2042 15.6929 17.9828 15.8367 17.711C16 17.4024 16 16.9985 16 16.1911V7.66667M7 7.66667H8.5M7 7.66667H5.5M8.5 7.66667H14.5M8.5 7.66667C8.5 6.99364 8.5 6.65729 8.61418 6.39185C8.76642 6.03792 9.05824 5.75655 9.42578 5.60995C9.70144 5.5 10.0511 5.5 10.75 5.5H12.25C12.9489 5.5 13.2984 5.5 13.574 5.60995C13.9416 5.75655 14.2335 6.03792 14.3857 6.39185C14.4999 6.65729 14.5 6.99364 14.5 7.66667M14.5 7.66667H16M16 7.66667H17.5"
          stroke="#3C3D3E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  </div>
);

export default DeleteIcon;
